import React from 'react';
import { CardAdWrapper } from './CardAd.style';
import MedrecAdSlot from '../global/adSlot/MedrecAdSlot';
import { useAdTargetingArguments } from './useAdTargetingArguments';

interface CardAdProps {
  adUnit: string;
  sect: string | string[];
  subsect?: string;
}

const CardAd: React.FC<CardAdProps> = ({ adUnit, sect, subsect }) => {
  const targetingArguments = useAdTargetingArguments(sect, subsect);
  return (
    <CardAdWrapper data-test="card-ad">
      <MedrecAdSlot targetingArguments={targetingArguments} adUnit={adUnit} />
    </CardAdWrapper>
  );
};

export default CardAd;
